export const Endpoints = {
  USER: {
    UPDATE: "user",
    REGISTER: "user",
  },
  AUTH: {
    LOGIN: "auth/login",
    ME: "auth/me",
  },
  IMAGE: {
    UPLOAD: "media",
  },
  PROPERTIES: {
    CREATE: "properties",
  },
  LISTINGS: {
    CREATE: "listings",
  },
  BLOG:{
   CREATE:"blog",
  },
  INVESMENTS: {
    CREATE: "investments",
  },
  PORTFOLIO: {
    CREATE: "portfolio",
  },
  CONSULTATIONS: {
    CREATE: "consultations",
    EMAILCONFIRM:"EmailConfirm"
  },
  MAP:{
    GEOCODE:"https://maps.googleapis.com/maps/api/geocode/json"
  },
  SETTINGS:{
    CREATE:"settings",
    PROPERTYCOUNT:"propertycount",
    RECENTPROPERTY:"recentproperty",
    PROPERTYSTATS:"propertystat",
    LISTINGSCOUNT:"listingsCount",
    INVESTMENTSCOUNT:"investmentsCount",
    PORTFOLIOSCOUNT:"portfoliosCount",
    CONSULTATIONSCOUNT:"consultationsCount"
  }
};
